/**
 * Construye una cadena de consulta (query string) a partir de un objeto de parámetros
 * Filtra automáticamente valores undefined, null y cadenas vacías
 *
 * @param {Object} params - Objeto con pares clave-valor para los parámetros de consulta
 * @returns {string} - Cadena de consulta codificada para URL
 *
 * @example
 * buildQueryString({ page: 1, limit: 10, search: 'test' })
 * // Retorna: "page=1&limit=10&search=test"
 *
 * buildQueryString({ id: 123, name: null, active: undefined })
 * // Retorna: "id=123" (filtra null y undefined)
 */
export const buildQueryString = (params = {}) => {
  const queryParams = new URLSearchParams()

  Object.entries(params).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== '') {
      queryParams.append(key, value)
    }
  })

  return queryParams.toString()
}

/**
 * Construye una ruta completa con parámetros de consulta para llamadas API
 * Combina una ruta base con parámetros de consulta de forma automática
 *
 * @param {string} basePath - La ruta base de la API (ej: '/api/v1/users')
 * @param {Object} params - Objeto con pares clave-valor para los parámetros de consulta
 * @returns {string} - Ruta completa con cadena de consulta
 *
 * @example
 * buildPathWithQuery('/api/v1/users', { page: 1, active: true })
 * // Retorna: "/api/v1/users?page=1&active=true"
 *
 * buildPathWithQuery('/api/v1/profile', {})
 * // Retorna: "/api/v1/profile" (sin query string si no hay parámetros)
 *
 * buildPathWithQuery('/api/v1/search', { q: 'plenna', filter: null })
 * // Retorna: "/api/v1/search?q=plenna" (filtra valores null)
 */
export const buildPathWithQuery = (basePath, params = {}) => {
  const queryString = buildQueryString(params)
  return queryString ? `${basePath}?${queryString}` : basePath
}
